module.exports = __webpack_public_path__ + "static/media/1516530.8ab33c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ourStaff/1516530.jpg
// module id = 1423
// module chunks = 0